<template>
  <section class="IP__authenticationFailure0021">
    <el-row :gutter="0" class="IP__authenticationFailureHead">
      <router-link to="/sp/0001" class="Router__To__Destination" tabindex="1">
        <i class="el-icon-close" tabindex="1"></i>
      </router-link>
      <el-col :span="6" class="whiteBg">
        <span class="IP__authenticationFailureSpan">IP認証失敗</span>
      </el-col>
      <el-col :span="12">
        <img src="../../assets/image/logo-new.png" alt="logo" class="ElnetLogo" />
      </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row class="IP__authenticationFailureBody">
      <div class="toaster">
        <div  v-if="this.getElNotice0021 != '' && this.getElNotice0021 != null " >
          <h5 v-show="El_Notice=true" >{{this.getElNotice0021}}</h5>
        </div>
      
        <div v-else >
          <h5 v-show="El_Notice" :title="this.getElNotice0021" ></h5>
        </div>
       
        
      </div>
      <div class="retain__login">
        <div v-if="this.getIpErrorMsg0021==true" >
          <h5 v-show="getIpErrorMsg0021=true">IP認証に失敗しました。</h5>
        </div>
        <div v-else >
          <h5 v-show="getIpErrorMsg0021"></h5>
        </div>
      </div>
      <el-button type="primary" @click="loginIp"  plain class="IPAuth__btn">リトライ</el-button>
      <router-link to="/sp/0001" class="Router__To__Destination Link__to__login" tabindex="1">
      <el-button type="info" @click="onSubmit" plain class="IPAuth__btn">ID/PW認証はこちら</el-button>
      </router-link>
    </el-row>
  </section>
</template>
 
<script>
import router from '../../router';
//import Common from '../../common/CommonFunc.js'
import { mapGetters } from "vuex";

export default {
  name: "IP__authenticationFailure0021",
  props: [],
  data() {
    return {
      getIpErrorMsg0021:true
    };
  },
  methods: {
    onSubmit() {
this.$LogButtonEvent("0021","IDPWcertification");
this.$LogMethodIN("0021","onSubmit");             
            router.push({name:"sp_0006"});
            this.$LogMethodOut("0021","onSubmit");
        },

    loginIp(){
this.$LogButtonEvent("0021","Retry");
this.$LogMethodIN("0021","loginIp");      
      this.getIpErrorMsg0021=false;

      this.$store.dispatch('sp_Communication0021/IpChecking').then(() => {
        var IpMsg = this.getIpErrorMsg0021True;
        this.getIpErrorMsg0021=IpMsg;

      }); 
      this.$LogMethodOut("0021","loginIp");
    }

  },
  computed: {
		...mapGetters("sp_Situation0021", [
      //error message flag for getting response
      "getElNotice0021",
      "getIpErrorMsg0021True"
		])
  },
  mounted() {
    this.$store.dispatch('sp_Communication0021/checkEl_Notice');


    },
  beforeCreate(){
      
      //Common.Session.CheckIsMobile("/sp/0021","/0021"); // MobileScreen Path, WebScreen Path
  }
};
</script>
<style scoped>
 @import "0021.css";
 @import "../../assets/css/customStyle.css"; 
</style>